import React, {Fragment, useState} from 'react';

import {Step4Form} from 'presentation/pages/public/sign-up/components/Forms';
import {translations} from 'presentation/translations-new';
import {Snackbar} from 'presentation/components';

const {successMessage} = translations['pt-br'].publicFlow.validateToken;

export function Step4() {
	const [isSnackbarOpen, setIsSnackbarOpen] = useState(true);

	const handleCloseSnackbar = () => {
		setIsSnackbarOpen(false);
	};

	return (
		<Fragment>
			<Step4Form />
			<Snackbar
				onClose={handleCloseSnackbar}
				message={successMessage}
				open={isSnackbarOpen}
			/>
		</Fragment>
	);
}
